import React from 'react';
import { mono, sans, useTheme } from '../tokens';

export default function Kpi({ label, value, sub, subColor }) {
  const t = useTheme();
  return (
    <div style={{ padding: '14px 18px' }}>
      <div style={{ fontSize: 9, color: t.textMuted, textTransform: 'uppercase', letterSpacing: 0.5, fontFamily: sans, fontWeight: 600, marginBottom: 4 }}>{label}</div>
      <div style={{ fontSize: 22, fontWeight: 700, fontFamily: mono, color: t.textPrimary, lineHeight: 1.1 }}>{value}</div>
      {sub && <div style={{ fontSize: 10, fontFamily: sans, color: subColor || t.textMuted, marginTop: 3 }}>{sub}</div>}
    </div>
  );
}
